import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-622dab5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-line" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
    /*#__PURE__*/_createTextVNode("Our Most "),
    /*#__PURE__*/_createElementVNode("span", { class: "color" }, "Profitable"),
    /*#__PURE__*/_createTextVNode(" Products!")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "title-text" }, " Guaranteed reliability and high-speed processing! ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "badge live"
}
const _hoisted_5 = {
  key: 1,
  class: "badge rng"
}
const _hoisted_6 = { class: "name" }
const _hoisted_7 = {
  key: 1,
  id: "coming-soon",
  class: "product"
}
const _hoisted_8 = {
  key: 0,
  class: "show-more"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FAIcon = _resolveComponent("FAIcon")!

  return (_openBlock(), _createElementBlock("div", {
    id: "desired-products",
    class: _normalizeClass({reducedPadding: _ctx.placement === 'products'})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", {
        id: "product-list",
        class: _normalizeClass(_ctx.placement)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (game) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: game.name,
            to: `/products/${game.url}/#product-view`,
            class: _normalizeClass(["product", {
            active: _ctx.activeGame === game.url,
          }])
          }, {
            default: _withCtx(() => [
              (game.live)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Live "))
                : _createCommentVNode("", true),
              (game.rng)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, " RNG "))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["icon", game.icon])
              }, null, 2),
              _createElementVNode("h4", _hoisted_6, _toDisplayString(game.name), 1)
            ]),
            _: 2
          }, 1032, ["to", "class"]))
        }), 128)),
        (_ctx.placement === 'home')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              id: "explore",
              class: "product",
              to: "/products"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, [
                  _createTextVNode(" Explore More "),
                  _createVNode(_component_FAIcon, {
                    icon: "arrow-right",
                    class: "ico"
                  })
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.placement === 'products')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("h4", null, [
                _createVNode(_component_FAIcon, {
                  icon: "ellipsis-h",
                  class: "ico"
                }),
                _createTextVNode(" Coming Soon ")
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.placement === 'home')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "btn",
              to: "/products"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Explore All Products ")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}